import { getTierFeatures } from '../lib/contestTiersConfig';
import type { ComparativeProduct, ContestProduct } from '../types';

export function useContestTiersConfig(products: ContestProduct[]): ComparativeProduct[] {
    if (!products) return [];
    return products.map((product: ContestProduct) => {
        const features = getTierFeatures(product.tier, product.category);

        return {
            ...product,
            collaborationMethod: 'COLLABORATION_METHOD_CONTEST',
            features,
        };
    });
}
